import * as Yup from 'yup';

export const initialValuesLensForm = {
    //modelNumber: '',
    //supplierId: '',
    //supplierName: '',
    manufacturerId: '',
    manufacturerBrandId: '',
    sku: '',
    supplierUpc: '',
    internalUpc: '',
    brand: '',
    brandId: '',
    location: '',
    type: 'lens',
    isTaxable: false,
    defaultTaxPercentage: 0.00,
    supplierCost: '',
    landingCost: '',
    listPrice: '',
    properties: {
        lensType: '',
        material:'',
        lensOu: '',
        sphere: '',
        cyl: '',
        axis: '',
        addPower: '',
        bc: '',
        size: '',
        ed: '',
        segHt: '',
        // New lens configuration fields
        lensModelId: '',
        lensMaterialId: '',
        lensIndexId: '',
        lensTreatmentIds: [],
    },
    markupMultiplier: '1.0',
    profit: '',
    profitPercentage: '',
    lastOrdered: '',
    lastReceived: '',
    lastSold: '',
    totalSold: '',
    returned: '',
    quantityOnOrder: '',
    quantityOnHand: '',
    status: 'active',
    notes: '',
    photos: ''
};

const lensValidationSchema = Yup.object({
    manufacturerId: Yup.string().required('Manufacturer is required'),
    manufacturerBrandId: Yup.string().required('Brand is required'),
    location: Yup.mixed(),
    //supplierName: Yup.string(),   
    supplierCost: Yup.number().positive('Supplier cost must be a positive number')
    .integer('Supplier cost must be an integer'),
    landingCost: Yup.number().positive('Landing cost must be a positive number'),
    listPrice: Yup.number().positive('List price must be a positive number')
    .required('List price is required'),
    photos: Yup.mixed()
});

export default lensValidationSchema;